export function numberToCommaString(number, fractionDigits) {
    let myNumber = number;
    if (fractionDigits) {
        myNumber = myNumber.toFixed(fractionDigits);
    }
    return myNumber.toString().replace('.',',');
}